import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

// attach token
client.interceptors.request.use((config) => {
  const token = localStorage.getItem("y9_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const fileUrl = (path) => `${API}/files/${path}`;

// public
export const createInquiry = (data) => client.post("/inquiries", data).then((r) => r.data);
export const getPortfolio = () => client.get("/portfolio").then((r) => r.data);
export const getServices = () => client.get("/services").then((r) => r.data);

// auth
export const login = (email, password) => client.post("/auth/login", { email, password }).then((r) => r.data);
export const getMe = () => client.get("/auth/me").then((r) => r.data);
export const setToken = (t) => localStorage.setItem("y9_token", t);
export const clearToken = () => localStorage.removeItem("y9_token");
export const hasToken = () => !!localStorage.getItem("y9_token");

// admin portfolio
export const addPortfolio = (file, category) => {
  const fd = new FormData();
  fd.append("file", file);
  fd.append("category", category);
  return client.post("/portfolio", fd, { headers: { "Content-Type": "multipart/form-data" } }).then((r) => r.data);
};
export const deletePortfolio = (id) => client.delete(`/portfolio/${id}`).then((r) => r.data);

// admin services
export const addService = (data) => client.post("/services", data).then((r) => r.data);
export const updateService = (id, data) => client.put(`/services/${id}`, data).then((r) => r.data);
export const deleteService = (id) => client.delete(`/services/${id}`).then((r) => r.data);

// admin inquiries
export const getInquiries = () => client.get("/inquiries").then((r) => r.data);
export const deleteInquiry = (id) => client.delete(`/inquiries/${id}`).then((r) => r.data);

// invitations (public)
export const getInvitationPublic = (id) => client.get(`/invitations/${id}`).then((r) => r.data);
export const submitRsvp = (id, data) => client.post(`/invitations/${id}/rsvp`, data).then((r) => r.data);
export const getPass = (code) => client.get(`/pass/${code}`).then((r) => r.data);
export const passQrUrl = (code) => `${API}/pass/${code}/qr?base=${encodeURIComponent(window.location.origin)}`;

// check-in (admin)
export const verifyPass = (code) => client.get(`/verify/${code}`).then((r) => r.data);
export const checkinPass = (code) => client.post(`/verify/${code}/checkin`).then((r) => r.data);

// invitations (admin)
export const createInvitation = (data) => client.post("/invitations", data).then((r) => r.data);
export const getInvitations = () => client.get("/invitations").then((r) => r.data);
export const getInvitationRsvps = (id) => client.get(`/invitations/${id}/rsvps`).then((r) => r.data);
export const deleteInvitation = (id) => client.delete(`/invitations/${id}`).then((r) => r.data);
